/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Typography,
  LinearProgress,
} from "@material-ui/core";

import {
  DoubleArrow as DoubleArrowIcon,
  ShoppingCart as ShoppingCartIcon,
  Cached as CachedIcon,
  Description as DescriptionIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Check as CheckIcon,
  LocalShipping as LocalShippingIcon,
  Store as StoreIcon,
  OpenInBrowser as OpenInBrowserIcon,
} from "@material-ui/icons";

import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import useLogs from "hooks/logs";

import componentStyles from "assets/theme/views/admin/react-bs-table";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import Api from "lib/api/httpRequestHelper";
import moment from "moment";

import { PrateleiraInfinitaIcon } from "components/Icon/PrateleiraInfinitaIcon";
import { BignumbersWorkFlowPrateleiraInfinita } from "components/Bignumbers/BignumbersWorkFlowPrateleiraInfinita";
import { DialogWorkflowProblemDetails } from "components/Dialogs/DialogWorkflowProblemDetails";
import { IsMobile900, IsMobile } from "utils/is-mobile";
import { getUserId } from "utils/get-user-info";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);
const useCustomStyles = makeStyles({
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
  scrollbarClass: {
    maxWidth: "100%",
    marginLeft: "0.3rem",
    overflowX: "auto",
    overflowY: "hidden",
    display: "inline-block",
    padding: 0,
    "&::-webkit-scrollbar": {
      height: "0.5rem!important",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 5,
      backgroundColor: `#a6a6a6`,
      outline: `#a6a6a6`,
    },
  },
});

const handleShowNextArrow = () => {
  return (
    <Box
      component={DoubleArrowIcon}
      style={{ color: "black", margin: "0 -0.3rem" }}
      width={"1.75rem!important"}
      height={"1.75rem!important"}
    />
  );
};

function WorkFlowPI() {
  const snackbar = useSnackbar();
  const classes = {
    ...useStyles(),
    ...useStylesCardDeck(),
    ...useCustomStyles(),
  };
  const { setLocalStorageApiProblem, setLocalStorageActions } = useLogs();

  const isMobile900 = IsMobile900();

  const isMobile = IsMobile();

  const userId = getUserId();
  const userIdVision = JSON.parse(localStorage.getItem("userDetailVision"));

  const [listDataProblem, setListDataProblem] = useState([]);
  const [orderProblem, setOrderProblem] = useState(null);
  const [openDialogDelivery, setOpenDialogDelivery] = useState(false);
  const [openDialogDetails, setOpenDialogDetails] = useState(false);
  const [typeProblem, setTypeProblem] = useState(null);
  const [searchingTotal, setSearchingTotals] = useState(false);
  const [searchingProblemOrders, setSearchingProblemOrders] = useState(false);
  const today = new Date();
  let formatDate = new Date(today.setDate(new Date().getDate()))
    .toISOString()
    .slice(0, 10);
  formatDate = moment().format("DD/MM/YYYY");

  const handleGetTotals = async () => {
    setSearchingTotals(true);
    const idUser = userIdVision ? userIdVision?.IdUsuario : userId;

    await Api.get("workflow-omni", "omnireport", `?User=${idUser}`, true)
      .then((value) => {
        setListDataProblem(value?.Result);
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "157",
          screen: "WorkFlow Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint workflow-omni - ${error}`,
        });
      })
      .finally(() => {
        setSearchingTotals(false);
      });
  };

  const handleGetProblemDetail = async () => {
    setSearchingProblemOrders(true);

    await Api.get(
      "list-order-workflow-omni",
      "omnireport",
      `?nrPedido=${typeProblem?.join(",")}`,
      true
    )
      .then((value) => {
        setOrderProblem(value?.Result);
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "157",
          screen: "WorkFlow Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint list-order-workflow-omni - ${error}`,
        });
      })
      .finally(() => {
        setSearchingProblemOrders(false);
      });
  };

  const DeliveryDetails = ({ onClose }) => {
    const deliveryRef = useRef(null);
    return (
      <Dialog
        open={Boolean(openDialogDelivery)}
        onClose={onClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent ref={deliveryRef}>
          <CardContent>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Grid container spacing={2}>
                <Typography style={{ marginBottom: "1.5rem" }}>
                  Retire na Loja
                </Typography>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <PrateleiraInfinitaIcon
                    icon={StoreIcon}
                    label={"Pedido Entregue Na Loja"}
                    number={listDataProblem?.PedidoEntregueNaLoja?.Total}
                    problem={listDataProblem?.PedidoEntregueNaLoja?.Problema}
                  />
                  {handleShowNextArrow()}
                  <PrateleiraInfinitaIcon
                    icon={OpenInBrowserIcon}
                    label={"Pedido Ag Retirada"}
                    number={listDataProblem?.PedidoAguardandoRetirada?.Total}
                    problem={
                      listDataProblem?.PedidoAguardandoRetirada?.Problema
                    }
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "2rem" }}>
                <Typography style={{ marginBottom: "1.5rem" }}>
                  Entrega em Domicílio
                </Typography>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", marginLeft: "-3rem" }}
                >
                  <PrateleiraInfinitaIcon
                    icon={CheckIcon}
                    label={"Pedido Entregue ao Cliente"}
                    number={listDataProblem?.PedidoEntregueAoCliente?.Total}
                    problem={listDataProblem?.PedidoEntregueAoCliente?.Problema}
                  />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </DialogContent>
      </Dialog>
    );
  };

  useEffect(() => {
    if (typeProblem && openDialogDetails) {
      handleGetProblemDetail(typeProblem);
    }
  }, [typeProblem, openDialogDetails]);

  useEffect(() => {
    handleGetTotals();
    setLocalStorageActions({
      nomeTela: "WorkFlow Prateleira Infinita",
      idMenu: "157",
      acao: "Acessou o menu WorkFlow Prateleira Infinita",
    });
  }, []);

  return (
    <>
      <HeaderClientes
        section="WorkFlow Pedidos Prateleira Infinita"
        subsection="Pedidos"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Dashline"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid
                  container
                  spacing={2}
                  style={{
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={ShoppingCartIcon}
                      tooltip={true}
                      tooltipMessage="Atendimentos em aberto nos últimos 60 dias"
                      label={"Atendimento aberto"}
                      number={listDataProblem?.AtendimentoAbertos?.Total}
                      problem={listDataProblem?.AtendimentoAbertos?.Problema}
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={CachedIcon}
                      tooltip={true}
                      tooltipMessage={`Pedidos Integrados em ${formatDate}`}
                      label={"Pedido integrado"}
                      number={listDataProblem?.PedidosIntegrados?.Total}
                      problem={listDataProblem?.PedidosIntegrados?.Problema}
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={DescriptionIcon}
                      label={"Aguardando XML"}
                      number={listDataProblem?.AguardandoXML?.Total}
                      problem={listDataProblem?.AguardandoXML?.Problema}
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={HourglassEmptyIcon}
                      tooltip={true}
                      tooltipMessage="Pedidos Aprovados"
                      label={"Pedido Ag Logística"}
                      number={listDataProblem?.AguardandoLogistica?.Total}
                      problem={listDataProblem?.AguardandoLogistica?.Problema}
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={HourglassEmptyIcon}
                      tooltip={true}
                      tooltipMessage="Pedidos não despachados"
                      label={"Pedido Ag Embarque"}
                      number={listDataProblem?.AguardandoEmbarque?.Total}
                      problem={listDataProblem?.AguardandoEmbarque?.Problema}
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      tooltip={searchingTotal ? false : true}
                      tooltipMessage="Ver detalhes da Entrega"
                      icon={LocalShippingIcon}
                      label={"Pedido em Trânsito"}
                      number={listDataProblem?.PedidoEmTransito?.Total}
                      problem={listDataProblem?.PedidoEmTransito?.Problema}
                      onClick={() =>
                        setOpenDialogDelivery(searchingTotal ? false : true)
                      }
                    />
                  </Grid>
                  {handleShowNextArrow()}
                  <Grid item xs={1}>
                    <PrateleiraInfinitaIcon
                      icon={CheckIcon}
                      label={"Pedido Entregue"}
                      number={listDataProblem?.PedidoEntregue?.Total}
                      problem={listDataProblem?.PedidoEntregue?.Problema}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={12}
            hidden={listDataProblem?.length === 0 || searchingTotal}
          >
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Status com Problemas"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <BignumbersWorkFlowPrateleiraInfinita
                  isMobile={isMobile}
                  isMobile900={isMobile900}
                  data={listDataProblem}
                  onClickLabel={(type) => {
                    setOpenDialogDetails(true);
                    setTypeProblem(type);
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          {openDialogDelivery && (
            <DeliveryDetails onClose={() => setOpenDialogDelivery(null)} />
          )}
          {openDialogDetails && (
            <DialogWorkflowProblemDetails
              orderProblem={orderProblem}
              openDialogDetails={openDialogDetails}
              searchingProblemOrders={searchingProblemOrders}
              onClose={() => {
                setOpenDialogDetails(null);
                setOrderProblem(null);
                setTypeProblem(null);
              }}
            />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: "flex", flexDirection: "column" }}
          hidden={!searchingTotal}
        >
          <span style={{ marginBottom: "0.5rem" }}>Buscando dados...</span>
          <LinearProgress />
        </Grid>
      </Container>
    </>
  );
}

export default WorkFlowPI;
